module.exports = __webpack_public_path__ + "static/gerardo_bledt-884506aa74c5a0ca26c40be27980cab2.jpg";